'use client';

// T038 — SupportMainnetPageShell.
//
// Spec: frontend/specs/030-mainnet-support-page/supplementary/wireframe.md
// + supplementary/wireframe-fullpage.md.
//
// V1 implementation renders a single-column layout for ALL variants. The
// `variant` prop is preserved on the API surface so the polish pass can wire
// the editorial / density / donation-forward shells without changing every
// caller. Variant C's right-rail can ship in a follow-up.

import type { ReactNode } from 'react';

import { cn } from '@/lib/ui/utils';

export type SupportMainnetVariant = 'baseline' | 'editorial' | 'density' | 'donation-forward';

export interface SupportMainnetPageShellProps {
  variant?: SupportMainnetVariant | undefined;
  children: ReactNode;
  className?: string | undefined;
}

// Section spacing only — horizontal gutter is owned by `AppShell`, the
// parent. Vertical rhythm (top below header / bottom above footer) is also
// owned by `AppShell` via `CONTENT_VERTICAL_CLASS`. Inner blocks that need
// reading-density typography (manifesto paragraphs, bios, disclaimer)
// constrain themselves with `max-w-prose` at the section level.
const SHELL_BASE = 'space-y-[3.6rem] md:space-y-[4.8rem]' as const;

export function SupportMainnetPageShell({
  variant: _variant = 'donation-forward',
  children,
  className,
}: SupportMainnetPageShellProps): React.ReactNode {
  return <div className={cn(SHELL_BASE, className)}>{children}</div>;
}
